import { ActionTree } from 'vuex';
import {
  EEditorUiAction,
  EEditorUiMutation,
} from '@/editor/editor-block/store/editor-ui.constants';
import { IEditorUiState } from '@/editor/editor-block/store/editor-ui.types';
import { RootState } from '@/store/store';
import {
  ICreateImage,
  ISelection,
  IStoredImage,
  IMenuCommand,
  ITextMenuState,
  IImageMenuState,
} from '@/editor/types';
import { EditorBlockService } from '@/editor/api/services/editor-block.service';
import { translate } from '@/helpers/translation.helper';

export const actions: ActionTree<IEditorUiState, RootState> = {
  async [EEditorUiAction.SetSelection]({ commit }, selection: ISelection) {
    commit(EEditorUiMutation.SetSelection, selection);
  },

  async [EEditorUiAction.ResetSelection]({ commit }) {
    commit(EEditorUiMutation.ResetSelection);
  },

  async [EEditorUiAction.UpdateTextMenuState]({ commit }, textMenuState: ITextMenuState) {
    commit(EEditorUiMutation.UpdateTextMenuState, textMenuState);
  },

  async [EEditorUiAction.UpdateImageMenuState](
    { commit },
    imageMenuState: Partial<IImageMenuState>
  ) {
    commit(EEditorUiMutation.UpdateImageMenuState, imageMenuState);
  },

  async [EEditorUiAction.TriggerMenuCommand]({ commit }, menuCommand: IMenuCommand) {
    commit(EEditorUiMutation.TriggerMenuCommand, menuCommand);
  },

  async [EEditorUiAction.CreateImage](
    { commit, dispatch },
    { documentPageId, createImage }: { documentPageId: string; createImage: ICreateImage }
  ) {
    commit(EEditorUiMutation.SetImageUploading);

    try {
      const image: IStoredImage = await EditorBlockService.createImage(createImage);
      dispatch(EEditorUiAction.CreateImageSuccess, { documentPageId, image });
    } catch (error) {
      dispatch(EEditorUiAction.CreateImageFailed, { documentPageId });
    }
  },

  async [EEditorUiAction.CreateImageSuccess](
    { commit },
    { documentPageId, image }: { documentPageId: string; image: IStoredImage }
  ) {
    commit(EEditorUiMutation.SetImageUploaded, { documentPageId, image });
  },

  async [EEditorUiAction.CreateImageFailed](
    { commit, dispatch },
    { documentPageId }: { documentPageId: string }
  ) {
    commit(EEditorUiMutation.SetImageUploadFailed, { documentPageId });
    dispatch('alert/showDangerAlert', translate('Failed-to-upload-image'), {
      root: true,
    });
  },

  async [EEditorUiAction.ResetCreateImage]({ commit }) {
    commit(EEditorUiMutation.ResetImageUpload);
  },
};
